var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "cls-1",
    d: "M25.85,1l1,6H30v7H28V9H27V31H22.22l-1-4H10.78l-1,4H5V9H4v5H2V7H5.15l1-6ZM8.72,27H7v2H8.22ZM25,27H23.28l.5,2H25Zm0-7H7v5H25ZM9.5,21A1.5,1.5,0,1,1,8,22.5,1.5,1.5,0,0,1,9.5,21Zm13,0A1.5,1.5,0,1,1,21,22.5,1.5,1.5,0,0,1,22.5,21ZM25,9H7v9H25Zm-.85-6H7.85L7.18,7H24.82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.356aea71.svg";
export { ForwardRef as ReactComponent };